import React from 'react';

// eslint-disable-next-line react/prop-types
const GrayDivider = ({ margin = 24 }) => {
  const dividerStyle = {
    borderBottom: '2px solid #E8E8E8',
    marginBottom: `${margin}px`,
    marginTop: `${margin}px`,
  };
  return <div style={dividerStyle} />;
};

export default GrayDivider;
